<template>
  <a-layout class="ehf-layout-wrap">
    <ehf-side v-if="!hidden" />
    <a-layout class="ehf-layout">
      <a-layout-header class="ehf-header" v-if="!hidden">
        <div class="left-box">
          <div class="collapse-btn" @click="toggleCollapse">
            <menu-unfold-outlined v-if="collapse" class="trigger" />
            <menu-fold-outlined v-else class="trigger" />
          </div>
          <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item v-for="(item, index) in levelList" :key="index">
              {{ item.meta.title }}
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
        <div class="right-info">
          <a-dropdown :trigger="['click']">
            <span style="cursor: pointer">
              {{ username }}({{ groupNames }})
              <a-avatar :src="avatar" />
            </span>
            <template v-slot:overlay>
              <a-menu @click="handleClickDropdown">
                <a-menu-item key="1">退出登录</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>
      <ehf-content :data-full-path="routeFullPath" />
    </a-layout>
  </a-layout>
</template>

<script>
  import EhfSide from './ehf-side'
  import EhfContent from './ehf-content'
  import { mapActions, mapGetters } from 'vuex'
  import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons-vue'
  import { useStore } from 'vuex'
  export default {
    name: 'Layout',
    components: {
      EhfSide,
      EhfContent,
      MenuFoldOutlined,
      MenuUnfoldOutlined,
    },
    data() {
      return {
        levelList: [],
        routeFullPath: '',
      }
    },
    setup() {
      const store = useStore()
      const WIDTH = 1024

      const isMobile = () => {
        const rect = document.body.getBoundingClientRect()
        return rect.width < WIDTH
      }

      const resizeHandler = () => {
        if (!document.hidden) {
          store.dispatch('settings/toggleDevice', isMobile() ? 'mobile' : 'desktop')

          if (isMobile()) {
            store.dispatch('settings/closeSideBar')
          }
        }
      }
      return {
        isMobile,
        resizeHandler,
      }
    },
    created() {
      this.getBreadcrumb()
      this.routeFullPath = this.$route.fullPath || ''
    },
    mounted() {
      this.resizeHandler()
      window.addEventListener('resize', this.resizeHandler)
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resizeHandler)
    },
    methods: {
      ...mapActions({
        toggleCollapse: 'settings/toggleCollapse',
        closeSideBar: 'settings/closeSideBar',
        logout: 'user/logout',
      }),
      getBreadcrumb() {
        const matched = this.$route.matched.filter((item) => !!item.meta.title)
        this.levelList = matched
        const route = this.$route
        if (route.meta.setBreadcrumb) {
          this.levelList.push({
            meta: {
              title: route.params.name,
            },
          })
        }
        if (matched.length === 1 && matched[0].path === '/') this.levelList = []
      },
      async handleClickDropdown({ key }) {
        if (key === '1') {
          // 退出登录
          await this.logout()
          this.$router.push({
            path: '/login',
          })
        }
      },
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        device: 'settings/device',
        hidden: 'settings/hidden',
        username: 'user/username',
        avatar: 'user/avatar',
        groups: 'user/groups',
        groupList: 'auth/groups',
      }),
      groupNames() {
        let names = []
        this.groups.forEach((group) => {
          const item = this.groupList.find((v) => v.id === group)
          if (item) {
            names.push(item.name)
          }
        })
        return names.join(',')
      },
    },
    watch: {
      $route(newVal) {
        this.getBreadcrumb()
        this.routeFullPath = newVal.fullPath || ''
        if (this.device === 'mobile' && !this.collapse) {
          this.closeSideBar()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ehf-layout-wrap {
    .ehf-layout {
      /*padding-left: 200px;*/
      transition: all 0.2s;
    }
    .ehf-collapse {
      .ehf-logo .anticon + span {
        display: inline-block;
        max-width: 0;
        opacity: 0;
        transition: all 0.2s;
      }
      & + .ehf-layout {
        padding-left: 81px;
        transition: all 0.2s;
      }
    }
    .ehf-header {
      padding: 0;
      background: #fff;
      display: flex;
      justify-content: space-between;
      height: 45px;
      .left-box {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        .breadcrumb {
          line-height: 40px;
        }
        .collapse-btn {
          line-height: 45px;
          cursor: pointer;
          .trigger {
            font-size: 18px;
            padding: 0 14px;
            transition: color 0.3s;
          }
          &:hover {
            .trigger {
              color: #1890ff;
            }
          }
        }
      }
      .right-info {
        padding: 0 20px;
        line-height: 45px;
      }
    }
  }
</style>
